import React from 'react';
import { ICON_PH } from '../../data/homeData';

/* Renders a sport/nav icon <img> at its real intended path; falls back to a
   neutral placeholder when the real PNG (live-server-only) isn't present. */
export default function IconImg({ src, className, alt = '' }) {
  return (
    <img
      className={className}
      src={src}
      alt={alt}
      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = ICON_PH; }}
    />
  );
}
